
export default {
    namespaced: true,
    state: {
        componentes: [],
        permisos: []
    },
    mutations: {
        SET_COMPONENTES(state, componentes){
            state.componentes = componentes
        },
        SET_PERMISOS(state, permisos){
            state.permisos = permisos
        }
    },
    actions: {
        setComponentes({commit}, componentes){
            commit('SET_COMPONENTES', componentes);
        },
        setPermisos({commit}, permisos){
            commit('SET_PERMISOS', permisos);
        }
    }
}